import PersonalLenderTile from 'personal-loan/rate-table/lender'
import StudentLoanLenderTile from 'student-loan/rate-table/lender'
import StudentLoanRefiLenderTile from 'student-loan-refi/rate-table/lender'
import MultiVerticalPersonalLenderTile from 'multi-vertical/rate-table/personal/components/lender-tile'
import MultiVerticalLenderTile from 'multi-vertical/rate-table/student-loan-refi/components/lender-tile'

const getLenderTileComponent = (name) => {
  switch (name) {
    case 'personalLoan':
      return PersonalLenderTile
    case 'StudentLoanRefi':
      return StudentLoanRefiLenderTile
    case 'StudentLoan':
      return StudentLoanLenderTile
    case 'multiVerticalPersonal':
      return MultiVerticalPersonalLenderTile
    case 'multiVerticalRefi':
      return MultiVerticalLenderTile
    case 'multiVerticalStudentLoan':
      return MultiVerticalLenderTile
    default:
      return null
  }
}

const compareLendersRate = (a, b) => parseFloat(a.minRate) - parseFloat(b.minRate)

export { getLenderTileComponent, compareLendersRate }
